import { render, staticRenderFns } from "./NavSearchResultsSuggestions.vue?vue&type=template&id=cceaf1b2"
import script from "./NavSearchResultsSuggestions.vue?vue&type=script&lang=js"
export * from "./NavSearchResultsSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports